export function scrollToElementById(
  elementId: string,
  options?: { behavior?: ScrollBehavior }
): boolean {
  const element = document.getElementById(elementId);
  if (!element) {
    return false;
  }

  element.scrollIntoView({ behavior: options?.behavior ?? 'smooth', block: 'start' });
  element.focus({ preventScroll: true });
  return true;
}
